import {useEffect} from "react";
import {useLocation} from "react-router-dom";

const ScrollToTop = () => {
    const {pathname} = useLocation();

    const stripLangFromPath = (path) => {
        return path.replace(/^\/[a-z]{2}(\/|$)/, '/'); // Removes "/en", "/fr", etc.
    };

    useEffect(() => {
        const currentPath = stripLangFromPath(pathname);

        // Store the previous path to compare
        const previousPath = ScrollToTop.previousPath || '';

        // Update the stored previous path
        ScrollToTop.previousPath = currentPath;
        const isButtonBackUsed = sessionStorage.getItem("fromBack");
        // Scroll to top only if the language-free path has changed
        if (currentPath !== previousPath && (isButtonBackUsed == null || isButtonBackUsed === "false")) {
            window.scrollTo(0, 0); // Scroll to the top
        }
        sessionStorage.removeItem("fromBack")

    }, [pathname]); // Runs whenever the path changes

    return null;
};

export default ScrollToTop;
